import { Injectable } from "@angular/core";
import {
  IPaginationResults,
  IShipperQuoteRequest,
  QuoteRequestService,
  QuoteRequestStatusEnum,
  QuoteService,
  QuoteStatusEnum,
  ShipperQuoteService,
} from "@cai-services";
import { from, Observable } from "rxjs";
import { QuoteRequest } from "../_models/quote-request.model";

@Injectable({
  "providedIn": "root",
})
export class ViewQuoteRequestService {
  constructor (
    private readonly quoteService: QuoteService,
    private readonly quoteRequestService: QuoteRequestService,
    private readonly shipperQuoteRequestService: ShipperQuoteService,
  ) {}

  retrieveQuoteRequestByForwarder (
    statusOption: {
      inStatus: QuoteRequestStatusEnum[];
      inQuoteStatus: QuoteStatusEnum[];
    },
    page: number,
    size: number,
    sort: string,
    filterOptions?: { [key: string]: any },
  ): Observable<any> {
    return from(
      this.quoteRequestService.getQuoteRequests(
        page,
        size,
        sort,
        statusOption?.inQuoteStatus,
        statusOption?.inStatus,
        filterOptions?.fromDate,
        filterOptions?.toDate,
        filterOptions?.origin,
        filterOptions?.destination,
        filterOptions?.airline,
        filterOptions?.commodity,
        filterOptions?.frequentFilter,
      ),
    );
  }

  retrieveShipperQuoteRequestByForwarder (
    page: number,
    size: number,
    sort: string,
    filterOptions: any,
  ): Observable<IPaginationResults<IShipperQuoteRequest>> {
    return from(this.shipperQuoteRequestService.getShipperQuoteRequests(
      page,
      size,
      sort,
      filterOptions?.frequentFilter,
      filterOptions?.fromDate,
      filterOptions?.toDate,
      filterOptions?.origin,
      filterOptions?.destination,
      filterOptions?.airline,
      filterOptions?.commodity,
      filterOptions?.search,
      ));
  }

  retrieveQuoteByQuoteId (quoteId: number): Observable<any> {
    return from(this.quoteService.retrieveQuoteById(quoteId));
  }

  updateQuoteRequestRating (quoterequest: QuoteRequest): Observable<any> {
    quoterequest.quoteItems = null;
    return from(
      this.quoteRequestService.updateQuoteRequestRating(quoterequest),
    );
  }
}
